import { generateArraySchema, generateBooleanSchema, generateColorSchema, generateMediaUrlSchema, generateNumberSchema, generateObjectSchema, generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { AudioParticleSpec, ImageParticleSpec, RichTextParticleSpec, TextParticleSpec, VideoParticleSpec } from "components/cards/particles/YinzCam";

export const specification = new BaseAtomSpec("Standings Card", generateRootObjectSchema({
  container: generateAtomContainerSchema({
    defaultValues: {}
  }),
  imgLeagueLogo: ImageParticleSpec.generateSchema("Competition Logo", "Upload/specify URL for competition logo", {
    defaultValues: {}
  }),
  layout: generateStringSchema("Table Layout", "Whether the table should be full or abbreviated.", {
    choices: ['full', 'abbr'],
    choiceTitles: ['Full', 'Abbreviated'],
    defaultValue: 'full'
  }),
  maxRows: generateNumberSchema("Maximum Rows", "The maximum number of rows to display in the table."),
  centerOnTeam: generateBooleanSchema("Center on Team", "Whether the table should centered on the current team if the rows are limited."),
  highlightTeam: generateBooleanSchema("Highlight Team", "Whether the current team should be highlighted in the table."),
  visibleColumns: generateArraySchema(
        "Visible Columns",
        "Optional list of stat columns to display and order. If empty, all datasource columns are shown.",
        generateStringSchema("Column Key", "A table column key to display.")
      ),
  headerLabels: generateArraySchema(
    "Header Labels",
    "Optional override labels for stat column headers.",
    generateObjectSchema("Header Label", "Single header label override.", {
      key: generateStringSchema("Column Key", "Column key from standings data."),
      label: generateStringSchema("Header Label", "Display label for this column key."),
    })
  ),
  tableColumns: generateArraySchema("Table Headers", "The list of additional table headers. Note that these are in addition to the baked-in columns specified for each data row.",
    generateStringSchema("Table Header", "The header text for a single (additional) column.")
  ),
  tableData: generateArraySchema("Table Data", "The list of table data rows.",
    generateObjectSchema("Table Data Row", "A single table data row. Additional properties should be specified to match the columns.", {
      position: generateStringSchema("Position", "The position number for this row."),
      teamLogo: generateMediaUrlSchema("Team Logo", "The URL of the team logo for this row."),
      teamTriCode: generateStringSchema("Team Abbreviation", "The abbreviation (tricode) of the team represented by this row."),
      teamName: generateStringSchema("Team Full Name", "The full name of the team represented by this row."),
      upDown: generateStringSchema("Position Up/Down", "Whether this position should be annotated with an increase or decrease in position from the previous week.", {
        choices: ['NONE', 'UP', 'DOWN'],
        choiceTitles: ['None', 'Up', 'Down'],
        defaultValue: 'NONE'
      }),
      recordType: generateStringSchema("Championship Flag", "Whether this position should be flagged with a color to indicate championship status.", {
        choices: ['NONE', 'GREEN', 'YELLOW', 'RED'],
        choiceTitles: ['None', 'Green', 'Yellow', 'Red'],
        defaultValue: 'NONE'
      }),
    }, { additionalProperties: true })
  ),
  hasGroupData: generateBooleanSchema("Has Group Data?", "Has Group Data?", { defaultValue: false }),
  groupTableData: generateArraySchema("Table Data", "The list of table data rows.",
    generateObjectSchema("Table Data Row", "A single table data row. Additional properties should be specified to match the columns.", {
      position: generateStringSchema("Position", "The position number for this row."),
      teamLogo: generateMediaUrlSchema("Team Logo", "The URL of the team logo for this row."),
      teamTriCode: generateStringSchema("Team Abbreviation", "The abbreviation (tricode) of the team represented by this row."),
      teamName: generateStringSchema("Team Full Name", "The full name of the team represented by this row."),
      upDown: generateStringSchema("Position Up/Down", "Whether this position should be annotated with an increase or decrease in position from the previous week.", {
        choices: ['NONE', 'UP', 'DOWN'],
        choiceTitles: ['None', 'Up', 'Down'],
        defaultValue: 'NONE'
      }),
      recordType: generateStringSchema("Championship Flag", "Whether this position should be flagged with a color to indicate championship status.", {
        choices: ['NONE', 'GREEN', 'YELLOW', 'RED'],
        choiceTitles: ['None', 'Green', 'Yellow', 'Red'],
        defaultValue: 'NONE'
      }),
      groupName: generateStringSchema("Group name", "Group name"),
      groupRank: generateStringSchema("Group Rank", "Group Rank")
    }, { additionalProperties: true }),
  ),
  groupNames: generateArraySchema("Group Name Array", "Group Name Array", generateStringSchema("Group Names", "Group Names")),
  groupHeaderBGColor: generateColorSchema("Group Header Color", "Group Header Color"),
  cardBGColor: generateColorSchema("Card Background Color", "Card Background Color"),
  tableHeaderBGColor: generateColorSchema("Table Header Background Color", "Table Header Background Color"),
  tableHeaderTextColor: generateColorSchema("Table Header Text Color", "Table Header Text Color"),
  tableHeaderFontFamily: generateStringSchema("Table Header Font Family", "Table Header Font Family"),
  tableHeaderFontSize: generateStringSchema("Table Header Font Size", "Table Header Font Size"),
  tableHeaderFontWeight: generateStringSchema("Table Header Font Weight", "Table Header Font Weight"),
  tableRowEvenBGColor: generateColorSchema("Even Row Background Color", "Even Row Background Color"),
  tableBorderColor: generateColorSchema("Table Border Color", "Table Border Color"),
  tableTextColor: generateColorSchema("Table Text Color", "Table Text Color"),
  tableDataFontFamily: generateStringSchema('Table Data Font Family', 'Table Data Font Family'),
  tableDataFontSize: generateStringSchema("Table Data Font Size", "Table Data Font Size"),
  tableDataFontWeight: generateStringSchema("Table Data Font Weight", "Table Data Font Weight"),
  highlightRowBGColor: generateColorSchema("Highlight Row Background Color", "Highlight Row Background Color"),
  highlightRowTextColor: generateColorSchema("Highlight Row Text Color", "Highlight Row Text Color"),
  showRowDividers: generateBooleanSchema("Show Row Dividers?", "Show Row Dividers?", {
    defaultValue: false,
  }),
  showPositionColumn: generateBooleanSchema("Show Position Column?", "Show Position Column?", {
    defaultValue: true,
  }),
  showLogoWrapper: generateBooleanSchema("Show Logo Wrapper?", "Show Logo Wrapper?", {
    defaultValue: true,
  }),
  showTeamLogo: generateBooleanSchema("Show Team Logo?", "Show Team Logo?", {
    defaultValue: true,
  }),
  teamShadowFlag: generateBooleanSchema("Shadow Required on Team Name?", "Shadow Required on Team Name?", { defaultValue: false }),
}));
